<template>
    <detail-editor-layout :title="$route.meta.type === 'create' ? $t('forms.create_template_title') : $t('forms.edit_template_title')">
        <div class="email-editor">
            <EmailEditor
                locale="cs"
                min-height="800px"
                style="height: 100%"
            />
        </div>
    </detail-editor-layout>
</template>
<script setup>
import DetailEditorLayout from '../../components/view-components/DetailEditorLayout.vue';
import { EmailEditor } from 'vue-email-editor';
</script>
<style scoped>
.email-editor
{
    margin: -12px;
    margin-top: -24px;
    height: 800px;
}
</style>